module.exports = __webpack_public_path__ + "static/img/wxcode1.663a40f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/wxcode1.png
// module id = xbB9
// module chunks = 62